export default __webpack_public_path__ + "static/media/scroll-down-mouse.0225a8b5.gif";